import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 pt-24 pb-32" data-testid="notfound-page">
      <p className="eyebrow mb-8">(404) — Not in the archive</p>
      <h1 className="serif-display text-6xl sm:text-7xl lg:text-[10rem] leading-[0.9]">
        A page that
        <br />
        <span className="serif-italic">never quite was.</span>
      </h1>
      <div className="grid md:grid-cols-12 mt-10">
        <p className="md:col-span-5 md:col-start-7 text-base md:text-lg leading-relaxed">
          The link you followed has wandered off. The studio is still here — try the work index, or
          write a short letter and we&apos;ll start from there.
        </p>
      </div>
      <div className="mt-12 flex gap-8 items-baseline">
        <Link to="/" className="font-serif text-2xl editorial-link" data-testid="notfound-home">
          <span className="serif-italic">Return home</span> →
        </Link>
        <Link to="/work" className="text-[0.78rem] tracking-[0.18em] uppercase font-sans editorial-link">
          See the work
        </Link>
      </div>
    </section>
  );
}
